import pdfMake from 'pdfmake/build/pdfmake';
import * as vfsFontsModule from 'pdfmake/build/vfs_fonts';

export type PdfMakeClient = {
  vfs?: Record<string, string>;
  createPdf: (docDefinition: unknown) => { download: (filename?: string) => void };
};

interface VfsFontsModule {
  pdfMake: { vfs: Record<string, string> };
}

const vfsModule = vfsFontsModule as unknown as VfsFontsModule & { default?: VfsFontsModule };

const client = pdfMake as PdfMakeClient;

if (!client.vfs) {
  client.vfs = (vfsModule.default?.pdfMake ?? vfsModule.pdfMake).vfs;
}

export default client;
